import { Box, HStack, Link, Image, Text, Divider, useBreakpointValue } from "@chakra-ui/react";
import React from "react";
import eduviclogo from "../../resources/Eduvictechlogo.png";
import { useTenant } from "../Routers/TenantContextProvider";
import { usePlatformSidebar, SIDEBAR_EXPANDED_WIDTH, SIDEBAR_COLLAPSED_WIDTH } from "./PrivateSidebarContext";

interface PrivateContentLayoutProps {
  children: React.ReactNode;
}

const PrivateContentLayout: React.FC<PrivateContentLayoutProps> = ({ children }) => {
  const { tenant } = useTenant();
  const { isCollapsed } = usePlatformSidebar();
  const showFooter = useBreakpointValue({ base: false, md: true });

  const marginLeft = `${isCollapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_EXPANDED_WIDTH}px`;

  return (
    <Box>
      <Box display="flex" flexDirection="column" minHeight="92.5vh" mt="69px">
        <Box as="main" flex="1" ml={marginLeft} transition="margin-left 0.25s ease">
          {children}
        </Box>

        {showFooter && (
          <Box
            as="footer"
            height="50px"
            bg="gray.700"
            color="white"
            textAlign="center"
            lineHeight="50px"
            fontSize="sm"
            ml={marginLeft}
            transition="margin-left 0.25s ease"
            w="100%"
            alignItems="center"
            justifyContent="center"
          >
            <HStack spacing={6} justifyItems={"center"}>
              <Link ml={4} href="/">
                <Image src={eduviclogo} alt="Eduvic Logo" maxH="45px" objectFit="contain" />
              </Link>
              <Divider orientation="vertical" height="30px" borderColor="gray.500" />
              <Text>© 2025 Eduvic Technologies.</Text>
              <Divider orientation="vertical" height="30px" borderColor="gray.500" />
              <Text>
                Eduvic Platform is operated by {tenant?.tenant_name} and supported by Eduvic Technologies.
              </Text>
              <Divider orientation="vertical" height="30px" borderColor="gray.500" />
              <Link href="/terms">Terms and Conditions</Link>
            </HStack>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default PrivateContentLayout;